<template>
    <div class="">

        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-pl-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-dark-grey">
            <div class="tw-text-4xl tw-uppercase tw-pt-0 tw-pb-1 mb-4">Current week</div>
        </div>

        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-pl-6 tw-pb-12">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-pr-1">
                <div v-if="productionReports667.length > 0">{{ productionReports667[0].report_date }}</div>
                <span @click="openLink(transformedProductionReports667[0].report_path)" :class="'tw-link'" v-if="productionReports667.length > 0">
                    <img src="storage/production_reports/667.jpeg" alt="667" style="max-width: 50%; height: auto;" />
                </span>
                <span @click="openLink(transformedProductionReports667[0].report_path)" :class="'tw-link'" v-if="productionReports667.length > 0">
                    <div class="mt-2 tw-text-sm">{{ productionReports667[0].report_name }}</div>
                </span>
                <div class="tw-border-0 md:tw-border-t md:tw-border-dark-grey mt-4" style="max-width: 50%;">
                    <div class="tw-text-sm mt-2">PLEASE NOTE THE FOLLOWING COLOUR CODES:</div>
                    <div class="tw-text-sm mt-2 tw-text-black"><u><b>Black</b></u> for all productions in the Toronto area</div>
                    <div class="tw-text-sm tw-text-green-700"><u><b>Green</b></u> for all productions in regional Ontario</div>
                    <div class="tw-text-sm tw-text-blue-700"><u><b>Blue</b></u> for all productions in Atlantic Canada</div>
                    <div class="tw-text-sm tw-text-purple-700"><u><b>Purple</b></u> for all productions in Newfoundland & Labrador</div>
                    <div class="tw-text-sm tw-text-red-700"><u><b>Red</b></u> indicates that a production is wrapped</div>
                </div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-pl-1">
                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-5">
                    <div v-if="productionReports669.length > 0">{{ productionReports669[0].report_date }}</div>
                    <span @click="openLink(transformedProductionReports669[0].report_path)" :class="'tw-link'" v-if="productionReports669.length > 0">
                        <img src="storage/production_reports/669.jpeg" alt="667" style="max-width: 50%; height: auto;" />
                    </span>
                    <span @click="openLink(transformedProductionReports669[0].report_path)" :class="'tw-link'" v-if="productionReports669.length > 0">
                    <div class="mt-2 tw-text-sm" v-if="productionReports669.length > 0">{{ productionReports669[0].report_name }}</div>
                </span>
                    <div class="tw-border-0 md:tw-border-t md:tw-border-dark-grey mt-4" style="max-width: 50%;">
                        <div class="tw-text-sm mt-2">PLEASE NOTE THE FOLLOWING COLOUR CODES:</div>
                        <div class="tw-text-sm mt-2 tw-text-black"><u><b>Black</b></u> for all productions in BC</div>
                        <div class="tw-text-sm tw-text-green-700"><u><b>Green</b></u> for all productions in Manitoba</div>
                        <div class="tw-text-sm tw-text-purple-700"><u><b>Purple</b></u> for all productions in Saskatchewan</div>
                        <div class="tw-text-sm tw-text-yellow-500"><u><b>Orange</b></u> indicates that a production is new to the list or rumour</div>
                        <div class="tw-text-sm tw-text-blue-700"><u><b>Blue</b></u> for all productions in Alberta</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-pl-6 tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-dark-grey">
            <div class="tw-text-4xl tw-uppercase tw-pt-0 tw-pb-1 mb-4">Past weeks</div>
        </div>
        <div class="tw-flex tw-flex-col tw-text-xl md:tw-flex-row tw-px-0 md:tw-pl-6 tw-pb-12">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-pr-1">
                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-5">
                    <template>
                        <div class="tw-border-0 md:tw-border-t md:tw-border-dark-grey" style="max-width: 50%;">
                            <div v-for="(report, index) in transformedProductionReports667.slice(0, 6)" :key="report.id">
                                <div v-if="index !== 0" class="record-container">
                                    <div class="record">
                                        <div class="record-name tw-text-sm">
                                            <span
                                                @click="openLink(report.report_path)"
                                                :class="[getReport667NameColorClass(report), 'tw-link']"
                                            >
                                                {{ report.report_name }}
                                            </span>
                                        </div>
                                        <div class="record-date tw-text-sm">{{ report.report_date }}</div>
                                    </div>
                                    <div class="tw-border-0 md:tw-border-t md:tw-border-dark-grey"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-pl-1">
                <div class="tw-flex tw-flex-col tw-w-full tw-font-light tw-pb-5">
                    <template>
                        <div class="tw-border-0 md:tw-border-t md:tw-border-dark-grey" style="max-width: 50%;">
                            <div v-for="(report, index) in transformedProductionReports669.slice(0, 6)" :key="report.id">
                                <div v-if="index !== 0" class="record-container">
                                    <div class="record">
                                        <div class="record-name tw-text-sm">
                                            <span
                                                @click="openLink(report.report_path)"
                                                :class="[getReport669NameColorClass(report), 'tw-link']"
                                            >
                                                {{ report.report_name }}
                                            </span>
                                        </div>
                                        <div class="record-date tw-text-sm">{{ report.report_date }}</div>
                                        </div>
                                    <div class="tw-border-0 md:tw-border-t md:tw-border-dark-grey"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>


    </div>
</template>


<script>

import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav";

export default {
    name: "ProductionReportsIndex",

    props: {
        productionreport667: Array,
        productionreport669: Array,
    },

    computed: {
        productionReports667() {
            return this.productionreport667 || []
        },
        productionReports669() {
            return this.productionreport669 || []
        },
        transformedProductionReports667() {
            return this.productionReports667.map(report => ({
                ...report,
                report_path: report.report_path.replace('public', 'storage')
            }));
        },
        transformedProductionReports669() {
            return this.productionReports669.map(report => ({
                ...report,
                report_path: report.report_path.replace('public', 'storage')
            }));
        },
    },

    methods: {
        getReport667NameColorClass(report) {
            const colorClasses = {
                'Toronto': 'tw-text-black !important',
                'Ontario': 'tw-text-green-700 !important',
                'Quebec': 'tw-text-purple-700 !important',
                'Wrapped': 'tw-text-red-700 !important',
                'Atlantic': 'tw-text-blue-700 !important',
                default: 'tw-text-black !important'
            };

            return colorClasses[report.report_info] || colorClasses.default
        },

        getReport669NameColorClass(report) {
            const colorClasses = {
                'BC': 'tw-text-black !important',
                'Manitoba': 'tw-text-green-700 !important',
                'Saskatchewan': 'tw-text-purple-700 !important',
                'New': 'tw-text-yellow-500 !important',
                'Alberta': 'tw-text-blue-700 !important',
                default: 'tw-text-black !important'
            };

            return colorClasses[report.report_info] || colorClasses.default
        },

        openLink(link) {
            window.open(link, '_blank')
        },
    },

    layout: (h, page) => {
        return h(AppLayoutSidebarNav, [
            page
        ])
    },
}
</script>

<style scoped>
.record-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.record {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}
.tw-link {
    text-decoration: underline;
    cursor: pointer;
}
</style>
